module.exports = __webpack_public_path__ + "img/logo.be7327ea.png";